import { useState } from 'react';
import Api from '../api/Api';
import { getErrorMessage } from '../constants/applicationFunnel';

const DIALOG = {
    PAUSE: 'pause',
    RESUME: 'resume',
    CANCEL: 'cancel',
    DELETED: 'deleted'
};

const redirectToLogoutCollection = () => {
    document.location.href = '/auth/logout';
};

const useCollectionDialogs = (canDeleteApplication = false) => {
    const [openedDialog, setOpenedDialog] = useState(() =>
        canDeleteApplication === true ? DIALOG.RESUME : undefined
    );
    const [deleteError, setDeleteError] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    const openDialog = (name) => {
        setDeleteError(null);
        setOpenedDialog(name);
    };

    const closeDialog = () => setOpenedDialog(undefined);

    const handlePause = async () => {
        try {
            await Api.User.signupCollectionFlowAbandonned();
        } catch (err) {
            console.error('Pause error:', err);
        } finally {
            redirectToLogoutCollection();
        }
    };

    const handleResume = () => {
        closeDialog();
    };

    const handleDelete = async () => {
        if (isDeleting) return;

        setIsDeleting(true);
        setDeleteError(null);

        try {
            await Api.User.deleteCollectionApplications();
            setOpenedDialog(DIALOG.DELETED);
        } catch (err) {
            console.error('Delete API Error:', err);
            setDeleteError(getErrorMessage(err));
        } finally {
            setIsDeleting(false);
        }
    };

    const handleFinalClose = () => {
        redirectToLogoutCollection();
    };

    return {
        dialogs: {
            pause: { open: openedDialog === DIALOG.PAUSE },
            resume: { open: openedDialog === DIALOG.RESUME },
            cancel: { open: openedDialog === DIALOG.CANCEL, error: deleteError, loading: isDeleting },
            deleted: { open: openedDialog === DIALOG.DELETED }
        },

        handlers: {
            pause: handlePause,
            resume: handleResume,
            delete: handleDelete,
            finalClose: handleFinalClose,
            navigateToCancelConfirm: () => openDialog(DIALOG.CANCEL),
            navigateBackToResume: () => openDialog(),
            closePause: closeDialog,
            openPause: () => openDialog(DIALOG.PAUSE)
        },

        actions: {
            openPause: () => openDialog(DIALOG.PAUSE),
            closePause: closeDialog
        }
    };
};

export default useCollectionDialogs;
